import axios from 'axios';
import { REST_HOSTNAME } from '../Config';
import { ScoreGrade, SentenceScoreStatus } from '../Score';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export interface ICharacterScore {
    order_index: number;
    character: string | null;
    expected_pinyin: string | null;
    spoken_pinyin: string | null;
    score: number | null;
    score_grade: ScoreGrade | null;
    is_silence: boolean | null;
    initial_grade?: ScoreGrade | null;
    initial_score?: number | null;
    final_grade?: ScoreGrade | null;
    final_score?: number | null;
    tone_grade?: ScoreGrade | null;
    tone_score?: number | null;
}

export interface ISentenceScore {
    id: number;
    created_at?: string;
    character_scores?: ICharacterScore[] | null;
    sentence_id: number;
    score: number[];
    text: string;
    passing_grade: ScoreGrade;
    score_grade: ScoreGrade[];
    pinyin_list_spoken: string[];
    pinyin_list_transcript: string[];
    audioData: Blob | null;
    first_name: string;
    score_mean: number;
    is_silence: boolean[];
    sentence_score_status?: SentenceScoreStatus;
}

export const ScoreApi = {
    getAll: function (since?: Date) {
        return axiosInstance.request<ISentenceScore[]>({
            method: "GET",
            url: `/sentence_score`,
            params: since ? { since: Math.floor(since.getTime() / 1000) } : undefined
        });
    },
    getScore: function (sentenceId: number, audio: any) {
        return axiosInstance.request<ISentenceScore>({
            method: "POST",
            url: `/sentence_score/${sentenceId}`,
            data: audio
        });
    },
    getScoreUrl: function (sentenceScoreId: number) {
        return axiosInstance.request<string>({
            method: "GET",
            url: `/sentence_score_url/${sentenceScoreId}`
        });
    },
    getPublicScore: function (publicSentenceScoreId: number) {
        return axiosInstance.request<ISentenceScore>({
            method: "GET",
            url: `/s/${publicSentenceScoreId}`
        });
    },
    getScoreBySentence: function (sentenceId: number) {
        return axiosInstance.request<ISentenceScore[]>({
            method: "GET",
            url: `/sentence_score/sentence/${sentenceId}`
        });
    },
    getAverageScoreByUser: function () {
        return axiosInstance.request({
            method: "GET",
            url: "/sentence_score/average_by_user",
        });
    },
    getSentenceScoresByUser: function (userName: string) {
        return axiosInstance.request({
            method: "GET",
            url: `/sentence_score/user/${encodeURIComponent(userName)}`,
        });
    },
}   
